import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../examPortal/portal.css";
// import {
//   fetchTraineeTestQuestions,
//   fetchTraineeTestAnswerSheet,
// } from "../../../actions/traineeAction";
import SingleQuestionResult from "./SingleQuestionResult";
import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import { fetchTraineeTestAnswerSheet, fetchTraineeTestQuestions } from "../../../features/trianeeAsync";

const QuestionResult = ({
  mode,
  triggerSidebar,
  totalScore,
  testName,
  totalMarks,
  data,
  isCorrect,
  reFetch,
  setReFetch,
  role,
}) => {
  const dispatch = useDispatch();
  const trainee = useSelector((state) => state.trainee);
  // console.log("Traineee",trainee);
  
  const [shouldRenderQuestion, setShouldRenderQuestion] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const traineeid = searchParams.get("traineeid");
  const testid = searchParams.get("testid");

  useEffect(() => {
    dispatch(fetchTraineeTestQuestions(testid));
    dispatch(fetchTraineeTestAnswerSheet({testid,userid:traineeid}));

    const timeoutId = setTimeout(() => {
      setShouldRenderQuestion(true);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [dispatch, testid, traineeid, reFetch]);

  return (
    <div className="question-holder-new">
      <div className="single-question-container-new">
        {shouldRenderQuestion &&
        trainee?.answers?.length > 0 &&
        trainee?.questions?.length > 0 ? (
          <SingleQuestionResult
            reFetch={reFetch}
            setReFetch={setReFetch}
            traineeid={traineeid}
            testId={testid}
            role={role}
            isCorrect={isCorrect}
            totalScore={totalScore}
            testName={testName}
            totalMarks={totalMarks}
            mode={mode}
            data={data}
            triggerSidebar={triggerSidebar}
            key={trainee.activeQuestionIndex}
          />
        ) : (
          <Spin
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems:"center",
              height:"100vh"
            }}
            size="large"
          />
        )}
      </div>
    </div>
  );
};

export default QuestionResult;
